module.exports = __webpack_public_path__ + "static/yUn2Cz+nSdGF5OkcREeMQA_thumb_36ff-566d478c6d61c1bbaa2a307f29715c45.jpg";